import { RecipeTypeClassification } from "../config/enums/recipeSimulator.enum";
import { Process } from "../api/recipeSimulator";

export const needsRecalculation = (dataView: any) => {
  if (!dataView?.last_updated || !dataView?.last_calculated) {
    return true;
  }
  const lastUpdated = new Date(dataView.last_updated);
  const lastCalculated = new Date(dataView.last_calculated);
 
  lastUpdated.setSeconds(0, 0);
  lastCalculated.setSeconds(0, 0);

  return lastUpdated > lastCalculated;
};

/**
 * Get user-friendly label for recipe type classification
 * @param type - Recipe type classification enum value
 * @returns Human-readable label for the recipe type
 * @example
 * getRecipeTypeLabel(RecipeTypeClassification.PUBLIC) // Returns: "Public"
 * getRecipeTypeLabel(undefined) // Returns: "Private"
 */
export const getRecipeTypeLabel = (
  type: RecipeTypeClassification | undefined
): string => {
  if (!type) {
    return "Private";
  }

  switch (type) {
    case RecipeTypeClassification.PUBLIC:
      return "Public";
    case RecipeTypeClassification.DEMOKIT:
      return "Demokit";
    case RecipeTypeClassification.PRIVATE:
      return "Private";
    default:
      return "Private";
  }
};

/**
 * Get color class for recipe type classification
 * Returns Tailwind CSS color class for visual differentiation
 * @param type - Recipe type classification enum value
 * @returns Tailwind color class string
 * @example
 * getRecipeTypeColor(RecipeTypeClassification.PUBLIC) // Returns: "text-blue-500"
 * getRecipeTypeColor(RecipeTypeClassification.DEMOKIT) // Returns: "text-orange-500"
 */
export const getRecipeTypeColor = (
  type: RecipeTypeClassification | undefined
): string => {
  if (!type) {
    return "text-gray-500";
  }

  switch (type) {
    case RecipeTypeClassification.PUBLIC:
      return "text-blue-500";
    case RecipeTypeClassification.DEMOKIT:
      return "text-orange-500";
    case RecipeTypeClassification.PRIVATE:
      return "text-gray-500";
    default:
      return "text-gray-500";
  }
};

/**
 * Check if a process is a duplicated process from another recipe
 * A process is considered duplicated if it has both originalRecipeId and originalProcessId
 * @param process - Process object to check
 * @returns True if process is duplicated, false otherwise
 * @example
 * isProcessDuplicated({ originalRecipeId: "123", originalProcessId: "456" }) // Returns: true
 * isProcessDuplicated({ originalRecipeId: "123" }) // Returns: false
 * isProcessDuplicated(undefined) // Returns: false
 */
export const isProcessDuplicated = (
  process: Process | undefined
): boolean => {
  if (!process) {
    return false;
  }

  // A process is considered duplicated only if it has BOTH relationship fields
  return !!(process.originalRecipeId && process.originalProcessId);
};
